import React, { useState } from "react";
import clsx from "clsx";
import { TbArrowsDiagonal2 } from "react-icons/tb";
import { TextArea as TextAreaProps } from "./index.types";
import "./index.css";
import Button from "../button";
import { getErrorMessage } from "../../utils/get-error-message";

export function TextArea({
  buttonDisabled = false,
  className = "",
  disabled = false,
  error = {
    is: false,
    message: "",
  },
  hasToggleButton = true,
  hideHeight = "5rem",
  label,
  labelClassName,
  isRequired,
  placeholder = "Insert value",
  showHeight = "10rem",
  backgroundColor,
  style = {},
  textareaClassName = "",
  ...rest
}: TextAreaProps): JSX.Element {
  const [isShow, setIsShow] = useState<boolean>(false);

  const handleClickToggle = () => {
    setIsShow((prev) => !prev);
  };

  return (
    <div
      className={clsx("textarea", className)}
      style={{ backgroundColor: backgroundColor, ...style }}
    >
      <div className="textarea__header">
        {label && <label className={labelClassName}>{label}</label>}
        {error && error.is && getErrorMessage(error.message) && (
          <span className="textarea__header--error">
            {getErrorMessage(error.message)}
          </span>
        )}
      </div>
      <textarea
        className={clsx(
          "textarea__input",
          error.is && "textarea__input--error",
          textareaClassName
        )}
        style={
          {
            height: hasToggleButton
              ? isShow
                ? showHeight
                : hideHeight
              : showHeight,
          } as React.CSSProperties
        }
        placeholder={placeholder}
        disabled={disabled}
        required={isRequired}
        {...rest}
      />
      {hasToggleButton && (
        <Button
          type="button"
          className={clsx(
            "textarea__button",
            isShow && "textarea__button--show",
            error.is && "textarea__button--error"
          )}
          onClick={handleClickToggle}
          disabled={buttonDisabled}
        >
          <TbArrowsDiagonal2 size="1.5rem" />
        </Button>
      )}
    </div>
  );
}

export default TextArea;
